import { render, staticRenderFns } from "./ChallengesLawMobile.vue?vue&type=template&id=8c7c6c52&"
import script from "./ChallengesLawMobile.vue?vue&type=script&lang=js&"
export * from "./ChallengesLawMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports